<template>
  <div class="checkbox">
    <p class="error m-0">{{ error }}</p>
    <div class="custom-checkbox flex">
      <label :for="computedId">{{ label }}</label>
      <input
        class="regular-checkbox"
        :type="type || 'checkbox'"
        :name="name"
        :id="computedId"
        :checked="isChecked"
        :disabled="disabled"
        @change="$emit('input', $event.target.checked)"
      />
    </div>
  </div>
</template>

<script>
export default {
  model: {
    prop: "isChecked",
    event: "input"
  },
  props: {
    label: {
      type: String
    },
    type: {
      type: String
    },
    name: {
      type: String
    },
    id: {
      type: String
    },
    isChecked: {
      type: Boolean,
      default: false
    },
    error: {
      type: String
    },
    disabled: {
      type: Boolean,
      default: false
    }
  },
  computed: {
    computedId() {
      return (
        this.id ||
        "checkbox-" +
          Math.random()
            .toString(36)
            .substr(2, 9)
      );
    }
  }
};
</script>

<style scoped>
.checkbox .custom-checkbox label {
  font-weight: 500;
  font-size: var(--fs-body);
  line-height: 1.4;
  letter-spacing: 0;
  text-transform: capitalize;
  color: var(--text);
  margin-right: 16px;
  font-family: var(--font-sans);
}
input[type="checkbox"] {
  position: relative;
  cursor: pointer;
  accent-color: var(--accent-600);
}
input[type="checkbox"]:before {
  content: "";
  display: block;
  position: absolute;
  width: 16px;
  height: 16px;
  top: 0;
  left: 0;
  border: 1px solid var(--line-strong);
  border-radius: var(--radius-sm);
  background-color: var(--surface);
}
input[type="checkbox"]:checked:before {
  background-color: var(--accent-600);
  border-color: var(--accent-600);
}
input[type="checkbox"]:checked:after {
  content: "";
  display: block;
  width: 5px;
  height: 10px;
  border: solid #ffffff;
  border-width: 0 2px 2px 0;
  -webkit-transform: rotate(45deg);
  -ms-transform: rotate(45deg);
  transform: rotate(45deg);
  position: absolute;
  top: 1px;
  left: 6px;
}
input[type="checkbox"]:disabled {
  cursor: not-allowed;
  opacity: 0.5;
}
</style>
